import "./Employers.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ExecutiveSearchProcess from "./sections/ExecutiveSearchProcess";
import TalentRequest from "./sections/TalentRequest";
import CorporateFooter from "@/reusable_sections/Footer";
export default function EmployersPage() {
  return <div>
      <MainNavigation />
      <ExecutiveSearchProcess />
      <TalentRequest />
      <CorporateFooter />
    </div>;
}